var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg7Eleven(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fillRule: "evenodd",
    height: 2429,
    viewBox: "0 -4.265 272.687 264.957",
    width: 2500,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.382-2.254h270.162v261.634h-270.162z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0-4.265h272.687v264.957h-272.687z",
    fill: "#008061"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168.128 243.26v10.607h-65.403v-10.627h-49.49c-4.836 0-8.775-5.055-8.775-11.287l-20.71-209.44c0-6.237 4.837-11.295 10.804-11.295h199.99c5.93 0 10.765 5.058 10.765 11.294l-20.475 209.441c0 6.232-3.94 11.287-8.775 11.287l-47.93.02z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.177 41.883h133.887c-13.183 4.942-53.313 32.113-63.336 50.381h-70.434l-.117-50.38z",
    fill: "#f5821f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m166.881 186.241c-1.91 18.245-1.989 40.463-1.989 63.8h-58.032c0-23.337.975-45.555 2.886-63.8z",
    fill: "#ed1b2d"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#008061"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m77.103 159.877v7.071h-9.282v7.074h9.282v8.105h-21.216v-37.717h21.216v8.401h-9.282v7.066zm49.334 0v7.071h-9.242v7.074h9.242v8.105h-21.176v-37.717h21.176v8.401h-9.242v7.066zm54.366 0v7.071h-9.282v7.074h9.282v8.105h-21.216v-37.717h21.216v8.401h-9.282v7.066zm-87.788-15.467v29.612h9.281v8.105h-21.215v-37.717zm50.545 25.491-4.526-25.49h-10.412l5.927 37.716h15.327l7.176-37.717h-8.852zm42.274-25.491h11.467v37.713h-11.467z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m197.3 155.607c.625-4.13 6.475-3.022 6.475-.663v27.183h11.504v-31.967c0-6.778-9.555-9.504-17.9-3.537l-.079 8.985z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m172.263 139.106c1.17-14.434 20.943-38.005 40.092-44.194v-55.685c-52.689 23.572-86.931 59.222-94.34 99.739z",
    fill: "#ed1b2d"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg7Eleven);
export default __webpack_public_path__ + "static/media/7-eleven.bdfde21882e15a6ce3b7df4a7e7d67e1.svg";
export { ForwardRef as ReactComponent };